document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('giftModal');
  const openBtn = document.getElementById('openGiftModal');
  const overlay = document.getElementById('closeGiftModal');
  const closeBtn = document.getElementById('closeGiftModalBtn');
  const saveBtn = document.getElementById('saveGiftDetails');

  // открыть
  openBtn.addEventListener('click', () => {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // закрыть
  [overlay, closeBtn].forEach(el =>
    el.addEventListener('click', () => {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    })
  );

  // сохранить
  saveBtn.addEventListener('click', () => {
    const form = document.getElementById('giftForm');
    const data = new FormData(form);
    const entries = Object.fromEntries(data);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ attributes: entries })
    })
    .then(() => {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
});
